<template>
  <BasePopover
    v-model="open"
    class="m-hint"
    :popper-id="popperId"
    :placement="placement"
    :options="resultPopperOptions"
    :reference-selector="referenceSelector"
    :reference-element="referenceElement"
    :visible-arrow="visibleArrow"
    :close-only-hover-popper-outside="closeOnlyHoverPopperOutside"
    :show-on="showOn"
    :offset="offset"
    :popper-class="popperClass"
    :allow-show="allowShow"
    @toggle="onToggle"
  >
    <template slot="reference">
      <slot />
    </template>
    <template slot="popper">
      <div
        class="m-hint__content-wrapper"
        :class="hintClass"
      >
        <slot name="content" />
      </div>
    </template>
  </BasePopover>
</template>

<script>
  import helpIcon from 'assets/icons/help.svg';
  import BasePopover from 'components/common/BasePopover';

  const defaultPopperOptions = {
    modifiers: {
      preventOverflow: {
        enabled: false
      }
    }
  };

  export default {
    name: 'MHint',
    components: {BasePopover},
    inheritAttrs: false,
    props: {
      placement: {
        type: BasePopover.props.placement.type,
        required: BasePopover.props.placement.required,
        default: BasePopover.props.placement.default
      },
      closeOnlyHoverPopperOutside: {
        type: BasePopover.props.closeOnlyHoverPopperOutside.type,
        default: BasePopover.props.closeOnlyHoverPopperOutside.default
      },
      popperId: {
        type: String,
        default: ''
      },
      popperOptions: {
        type: Object,
        default: Object
      },
      referenceElement: {
        type: HTMLElement,
        default: null
      },
      referenceSelector: {
        type: String,
        default: null
      },
      offset: {
        type: String,
        default: '0,5'
      },
      hintClass: {
        type: [String, Array, Object],
        default: ''
      },
      visibleArrow: {
        type: Boolean,
        default: true
      },
      showOn: {
        type: String,
        default: 'hover'
      },
      popperClass: {
        type: String,
        default: null
      },
      allowShow: {
        type: Boolean,
        default: true
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        open: false,
        helpIcon
      };
    },
    computed: {
      resultPopperOptions () {
        return {...defaultPopperOptions, ...this.popperOptions};
      }
    },
    watch: {
      visible (value) {
        this.open = value;
      }
    },
    methods: {
      onToggle (value) {
        this.$emit('toggle', value);
      }
    }
  };
</script>

<style>
  .m-hint .popper {
    box-shadow: 0 0 10px rgba(134, 134, 134, 0.25);
  }

  .m-hint__content-wrapper {
    font-size: 12px;

    /* center contents */
    display: flex;

    justify-content: center;
    align-items: center;

    box-sizing: border-box;
    width: max-content;
    max-width: 269px;
    min-width: 0;

    padding: 14px 12px 16px;
  }
</style>
